const socialData =
{
  metadata: {
    totalFollowers: 23004
  },
  data: [
    {
      id: 0,
      label: "Facebook",
      logo: "./images/icon-facebook.svg",
      handle: "@nathanf",
      stats: [
        {
          label: "Followers",
          amount: 1987,
          change: 12,
        },
        {
          label: "Page Views",
          amount: 87,
          change: 3,
        },
        {
          label: "Likes",
          amount: 52,
          change: -2,
        },
      ],
    },
    {
      id: 1,
      label: "Twitter",
      logo: "./images/icon-twitter.svg",
      handle: "@nathanf",
      stats: [
        {
          label: "Followers",
          amount: 1044,
          change: 99,
        },
        {
          label: "Retweets",
          amount: 117,
          change: 303,
        },
        {
          label: "Likes",
          amount: 507,
          change: 553,
        },
      ],
    },
    {
      id: 2,
      label: "Instagram",
      logo: "./images/icon-instagram.svg",
      handle: "@realnathanF",
      stats: [
        {
          label: "Followers",
          amount: 11000,
          change: 1099,
        },
        {
          label: "Likes",
          amount: 5462,
          change: 2257,
        },
        {
          label: "Profile Views",
          amount: 52000,
          change: 1375,
        },
      ],
    },
    {
      id: 3,
      label: "YouTube",
      logo: "./images/icon-youtube.svg",
      handle: "Nthan F.",
      stats: [
        {
          label: "Subscribers",
          amount: 8239,
          change: -144,
        },
        {
          label: "Likes",
          amount: 107,
          change: -19,
        },
        {
          label: "Total Views",
          amount: 1407,
          change: -12,
        },
      ],
    },
  ]
};

export default socialData;
